import { namespaces, get_namespace_bundle } from 'cache-store';
import { svc } from './support/i18nsvc';
export async function get_bundle(namespace) {
    return await get_namespace_bundle({
        ns: namespace,
        svc_call: () => (namespace === 'lpl1' ? svc.get_lpl1_text() : svc.get_i18n_text({ namespace }))
    });
}
export async function bundle_map(namespaces) {
    const promises = namespaces.map((ns) => {
        return get_namespace_bundle({
            ns,
            svc_call: () => (ns === 'lpl1' ? svc.get_lpl1_text() : svc.get_i18n_text({ namespace: ns }))
        });
    });
    const bundles = await Promise.all(promises);
    return new Map(bundles.map((bundle, idx) => {
        return [namespaces[idx], bundle];
    }));
}
export async function load_dynls(ignore = [], addLpl = false) {
    const ns = await namespaces({ svc_call: () => svc.get_i18n_namespaces(), ignore, addLpl });
    return bundle_map(ns);
}
